import { SINGLE_API } from 'src/redux/actions/type';

export const getAmountInfotRequest = (payload, next, nextError) => {
	return {
		type: SINGLE_API,
		payload: {
			uri: '/dashboard/amount-info',
			params: payload,
			beforeCallType: 'GET_DASHBOARD_AMOUNT_INFOR_RESTAURANT_REQUEST',
			successType: 'GET_DASHBOARD_AMOUNT_INFOR_RESTAURANT_SUCCESS',
			afterSuccess: next,
			afterError: nextError
		}
	};
};

export const getTopIncomeRestaurant = (payload, next, nextError) => {
	return {
		type: SINGLE_API,
		payload: {
			uri: '/dashboard/top-income-restaurant',
			params: payload,
			beforeCallType: 'GET_DASHBOARD_INCOM_RESTAURANT_REQUEST',
			successType: 'GET_DASHBOARD_INCOM_RESTAURANT_SUCCESS',
			afterSuccess: next,
			afterError: nextError
		}
	};
};

export const getLastFiveRestaurantCreated = (payload, next, nextError) => {
	return {
		type: SINGLE_API,
		payload: {
			uri: '/dashboard/last-five-restaurant-created',
			// params: payload,
			// beforeCallType: 'GET_DASHBOARD_INCOM_RESTAURANT_REQUEST',
			// successType: 'GET_DASHBOARD_INCOM_RESTAURANT_SUCCESS',
			afterSuccess: next,
			afterError: nextError
		}
	};
};
export const getTopAffectCompany = (payload, next, nextError) => {
	return {
		type: SINGLE_API,
		payload: {
			uri: '/dashboard/get-expenses-company',
			params: payload,
			beforeCallType: 'GET_DASHBOARD_AFFECT_COMPANY_REQUEST',
			successType: 'GET_DASHBOARD_AFFECT_COMPANY_SUCCESS',
			afterSuccess: next,
			afterError: nextError
		}
	};
};

export const getDashboardCompany = (payload, next, nextError) => {
	const { params } = payload;
	return {
		type: SINGLE_API,
		payload: {
			uri: '/dashboard/company',
			params,
			beforeCallType: 'GET_DASHBOARD_COMPANY_REQUEST',
			successType: 'GET_DASHBOARD_COMPANY_SUCCESS',
			afterSuccess: next,
			afterError: nextError
		}
	};
};

export const getDashboardRestaurant = (payload, next, nextError) => {
	const { params } = payload;
	return {
		type: SINGLE_API,
		payload: {
			uri: '/dashboard/restaurant',
			params,
			beforeCallType: 'GET_DASHBOARD_RESTAURANT_REQUEST',
			successType: 'GET_DASHBOARD_RESTAURANT_SUCCESS',
			afterSuccess: next,
			afterError: nextError
		}
	};
};

export const getBalanceBankUnpaid = (payload, next, nextError) => {
	const { params } = payload;
	return {
		type: SINGLE_API,
		payload: {
			uri: '/dashboard/get-balance-bank-unpaid',
			params,
			beforeCallType: '',
			successType: '',
			afterSuccess: next,
			afterError: nextError
		}
	};
};

export const setBalanceBank = (payload, next, nextError) => {
	const { params } = {
		params: payload
	};
	return {
		type: SINGLE_API,
		payload: {
			opt: { method: 'POST' },
			uri: '/dashboard/set-balance-bank-unpaid',
			params,
			beforeCallType: '',
			successType: '',
			afterSuccess: next,
			afterError: nextError
		}
	};
};
